import moment from 'moment';
import 'moment-timezone';

export const INDISPONIBILIDADE_2025 = [
  moment.tz(new Date('2025-12-24 14:00'), 'America/Sao_Paulo').toDate(),
  moment.tz(new Date('2025-12-31 14:00'), 'America/Sao_Paulo').toDate(),
];
